import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priorityEmployeeLabelSlider'
})
export class PriorityEmployeeLabelSliderPipe implements PipeTransform {

  transform(value: number): string {


    if (!(value > 0))
    {
      return 'Sin calificar o más'
    }
    return `${value} o más`
  }
}
